// Stubs for Capacitor native modules when running in a browser/web context.
// Prevents "Failed to resolve module specifier" errors.

const noopAsync = () => Promise.resolve({} as any);
const noopPlugin = new Proxy({}, {
  get: () => noopAsync,
});

// @capacitor/core
export const Capacitor = {
  isNativePlatform: () => false,
  getPlatform: () => 'web',
  isPluginAvailable: () => false,
};
export const registerPlugin = (_name: string) => noopPlugin;
export const WebPlugin = class {};
export const Plugins = new Proxy({}, { get: () => noopPlugin });

// @capacitor/app
export const App = noopPlugin;

// @capacitor/camera
export const Camera = noopPlugin;
export const CameraResultType = { Uri: 'uri', Base64: 'base64', DataUrl: 'dataUrl' };
export const CameraSource = { Prompt: 'PROMPT', Camera: 'CAMERA', Photos: 'PHOTOS' };

// @capacitor/filesystem
export const Filesystem = noopPlugin;
export const Directory = {
  Documents: 'DOCUMENTS',
  Data: 'DATA',
  Library: 'LIBRARY',
  Cache: 'CACHE',
  External: 'EXTERNAL',
  ExternalStorage: 'EXTERNAL_STORAGE',
};
export const Encoding = { UTF8: 'utf8', ASCII: 'ascii', UTF16: 'utf16' };

// @capacitor/share
export const Share = noopPlugin;

// @capacitor/local-notifications
export const LocalNotifications = noopPlugin;

// @capacitor/push-notifications
export const PushNotifications = noopPlugin;

// @capacitor/browser
export const Browser = noopPlugin;

// @capacitor/splash-screen
export const SplashScreen = noopPlugin;

// @capacitor/privacy-screen & @capacitor-community/privacy-screen
export const PrivacyScreen = noopPlugin;

// @aparajita/capacitor-biometric-auth
export const BiometricAuth = noopPlugin;
export const BiometryType = { none: 0, touchID: 1, faceID: 2, fingerprintAuthentication: 3, faceAuthentication: 4, irisAuthentication: 5 };

// @aparajita/capacitor-secure-storage
export const SecureStorage = noopPlugin;

// @capawesome-team/capacitor-android-foreground-service
export const ForegroundService = noopPlugin;

// @capgo/capacitor-native-biometric
export const NativeBiometric = noopPlugin;

// @independo/capacitor-voice-recorder & capacitor-voice-recorder
export const VoiceRecorder = noopPlugin;
export const RecordingData = {};

// Default export for packages that use default imports
export default {
  Capacitor,
  registerPlugin,
  WebPlugin,
  Plugins,
};
